/**
 * Whether a string|{pill} segments array contains at least one real, resolved pill -- as
 * opposed to being pure, untokenized plain text (e.g. a search that was only ever typed as free
 * text, never clicked/matched into a real term).
 *
 * Shared by two symmetric decisions that must agree with each other, or a search flips back and
 * forth between its tokenized and translated forms depending on which screen it's viewed from:
 * - SearchResults.js: whether to trust a search's own `lastSearchSegments` or fall back to
 *   translating the backend's parsed `parameters` into pills.
 * - LandingPage.js: whether to trust a saved search's own `originalSegments` or fall back to
 *   translating its saved `parameters` the same way. Real bug report: a saved search that was
 *   only ever typed as free text (so `originalSegments` was just that plain sentence, no pill in
 *   it) reapplied as the same plain, untokenized text instead of the rich pills the backend's
 *   parse had already produced for it once -- `originalSegments` being merely *present* isn't
 *   the same as it containing anything worth preserving over the richer translation.
 */
export function segmentsContainRealPill(segments) {
  return (
    Array.isArray(segments) &&
    segments.some((segment) => typeof segment === "object" && segment !== null && "pill" in segment)
  );
}
